<main >
  <div id="fade" (click)="close()" ></div >

  <div
    id="modal"
    [ngClass]="{
      'modal-desktop': !isMobile,
      'modal-mobile': isMobile
    }"
  >
    <div class="modal-header" >
      <div class="header-content" >
        <span class="title" >{{ title }}</span >
        <span class="material-symbols-outlined icon" (click)="close()" >close</span >
      </div >
    </div >

    <div class="modal-content" >
      <div class="modalbody" >
        <ng-content ></ng-content >
      </div >
    </div >
  </div >
</main >
